export const TEST_ID = 'onboardingContent';
